import { CartsDataViewContext } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SavedOrderListPageContext } from "@insite/content-library/Pages/SavedOrderListPage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface SavedOrdersResultCountStyles {
    orderCountText?: TypographyPresentationProps;
}

export const resultCountStyles: SavedOrdersResultCountStyles = {
    orderCountText: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
        `,
    },
};

const styles = resultCountStyles;

const SavedOrdersResultCount: FC<WidgetProps> = () => {
    const ordersDataView: any = useContext(CartsDataViewContext);

    if (!ordersDataView.value || !ordersDataView.pagination) {
        return null;
    }

    const { totalItemCount } = ordersDataView?.pagination?.totalItemCount || 0;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.orderCountText} data-test-selector="savedOrders_resultCount">
            {ordersDataView?.pagination?.totalItemCount} {translate("orders")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: SavedOrdersResultCount,
    definition: {
        group: "Saved Order List",
        displayName: "Result Count",
        allowedContexts: [SavedOrderListPageContext],
    },
};

export default widgetModule;
